<div class="content">
  <form class="occupational-form" [formGroup]="occupationalAndDemographicalHistoryForm" (submit)="submit()">
    <mat-form-field>
      <mat-label>{{ 'occupation' | translate }}</mat-label>
      <input matInput type="text" name="Occupation" formControlName="occupation" gcFormField gcFormFieldNoError />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'note' | translate }}</mat-label>
      <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
    </mat-form-field>
    <button
      mat-flat-button
      type="submit"
      [ngClass]="{ primary: requestUuid === null, accent: requestUuid !== null }"
      class="save-button"
      [disabled]="occupationalAndDemographicalHistoryForm.invalid"
    >
      {{ 'save_occupation' | translate }}
    </button>
  </form>
</div>
